import { schluesselFehler, schluesselVorschlag } from "@gui-creator/gemeinsam";
import { useState } from "react";

type Modus = "name" | "schluessel";

/** Eingabezeile im Baum; Enter übernimmt, Escape bricht ab. Fehler des Servers bleiben am Feld stehen. */
export function InlineEingabe({
  tiefe,
  modus,
  anfang = "",
  platzhalter,
  onFertig,
  onAbbrechen,
}: {
  tiefe: number;
  modus: Modus;
  anfang?: string;
  platzhalter: string;
  onFertig: (wert: string) => Promise<void>;
  onAbbrechen: () => void;
}) {
  const [wert, setWert] = useState(anfang);
  const [fehler, setFehler] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);
  const schluessel = modus === "schluessel" ? wert.trim() : schluesselVorschlag(wert);
  const lokalerFehler = wert.trim() === "" ? null : schluesselFehler(schluessel);

  const uebernehmen = async () => {
    if (laeuft) return;
    if (wert.trim() === "") return onAbbrechen();
    if (lokalerFehler) return setFehler(lokalerFehler);
    setLaeuft(true);
    try {
      await onFertig(wert.trim());
    } catch (e) {
      setFehler((e as Error).message);
      setLaeuft(false);
    }
  };

  return (
    <div className="baum-inline" style={{ paddingLeft: 8 + tiefe * 14 }}>
      <input
        className="eingabe baum-inline-feld"
        autoFocus
        value={wert}
        placeholder={platzhalter}
        aria-label={platzhalter}
        aria-invalid={!!fehler}
        disabled={laeuft}
        onChange={(e) => {
          setWert(e.target.value);
          setFehler(null);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") void uebernehmen();
          if (e.key === "Escape") onAbbrechen();
        }}
        onBlur={() => {
          if (!fehler && !laeuft) void uebernehmen();
        }}
      />
      {fehler ? (
        <span className="feld-fehler">{fehler}</span>
      ) : (
        wert.trim() !== "" && modus === "name" && <span className="feld-hinweis">Schlüssel: <span className="mono">{schluessel || "…"}</span></span>
      )}
    </div>
  );
}
